import TextButton from 'LuxKit/Button/TextButton'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Caption from 'LuxKit/Typography/Caption'
import Heading from 'LuxKit/Typography/Heading'
import FormatCurrency from 'components/Common/FormatCurrency'
import { withOfferPageAndReduxState } from 'contexts/OfferPage/withOfferPageState'
import type { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'
import { takeCurrentOfferState } from 'contexts/OfferPage/offerPageStateReducer'
import {
  getMultiRoomPackagesForFilters, getSelectedOfferPageMultiRoomDay,
} from 'selectors/offerPage/multipleRoomBookingSelectors'
import { getPackagesForFilters, getSelectedOfferPageDay } from 'selectors/offerPage/offerPageSelectors'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import Group from 'components/utils/Group'
import { isMultipleRoomBookingActive } from 'selectors/offerPage/offerPageSharedSelectors'
import type { BundleSelectedDaysInfo } from 'selectors/offerPage/bundledOfferPageSelectors'
import { getBundleSelectedDays } from 'selectors/offerPage/bundledOfferPageSelectors'

interface Props {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void
  className?: string
  relevantPackages: Array<App.OfferPackageOptionView>
  selectedDay?: App.CalendarDay
  activeFilter?: OfferPageFilterType
  bundleSelectedDays: BundleSelectedDaysInfo
}

function OfferFilterSidebarBottomPanel(props: Props) {
  const { onClick, relevantPackages, selectedDay, activeFilter, bundleSelectedDays } = props
  const intl = useIntl()

  const nightsTwoHotelsFromLabel = intl.formatMessage(
    {
      id: 'uUTJcrGFnn',
      defaultMessage: '{nights, plural, one {# night} other {# nights}}, 2 hotels from',
      description: 'Bundle sidebar bottom panel caption with nights, 2 hotels, and from',
    },
    { nights: bundleSelectedDays.duration },
  )
  const nightsTwoHotelsLabel = intl.formatMessage(
    {
      id: 'sX6gR+JInO',
      defaultMessage: '{nights, plural, one {# night} other {# nights}}, 2 hotels',
      description: 'Bundle sidebar bottom panel caption with nights and 2 hotels',
    },
    { nights: bundleSelectedDays.duration },
  )

  return (
    <ModalFooter>
      <Group
        direction="horizontal"
        horizontalAlign="space-between"
        verticalAlign="end"
      >
        <div>
          <Caption variant="large">
            {relevantPackages.length !== 1 ? nightsTwoHotelsFromLabel : nightsTwoHotelsLabel}
          </Caption>
          <FormattedMessage
            id="eoGVq/ombo"
            defaultMessage="<price>{priceValue}</price> <label>total</label>"
            description="Total price with label in bundle sidebar bottom panel"
            values={{
              priceValue: <FormatCurrency value={bundleSelectedDays.hotelTotal} />,
              price: (chunks) => <Heading as="span" variant="heading5">{chunks}</Heading>,
              label: (chunks) => <Caption as="span" variant="large">{chunks}</Caption>,
            }}
          />
        </div>
        <div>
          {(activeFilter !== 'checkin' || !!selectedDay) &&
            <TextButton
              kind="primary"
              size="large"
              onClick={onClick}
              type="submit"
            >
              {intl.formatMessage({
                id: 'Tm8uhS5S6Y',
                defaultMessage: 'Continue',
                description: 'Button text to continue in bundle offer sidebar panel',
              })}
            </TextButton>}
        </div>
      </Group>
    </ModalFooter>
  )
}

export default withOfferPageAndReduxState((currentState, appState) => {
  const state = takeCurrentOfferState(currentState)
  const isMultiRoom = isMultipleRoomBookingActive(state, appState)

  return {
    bundleSelectedDays: getBundleSelectedDays(appState, currentState),
    relevantPackages: isMultiRoom ? getMultiRoomPackagesForFilters(state, appState) : getPackagesForFilters(appState, state),
    selectedDay: isMultiRoom ? getSelectedOfferPageMultiRoomDay(state, appState) : getSelectedOfferPageDay(appState, state),
  }
}, OfferFilterSidebarBottomPanel)
